function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import CheckBox from "../Form/CheckBox";
import Icon from "../Icon/Icon";
export const contextMenuItemSelector = "data-ax-context-menu-item";
export default class ContextMenuItem extends Component {
  render() {
    const {
      children,
      className,
      disabled,
      icon,
      indeterminate,
      onClick,
      multiSelect,
      selected,
      paddingVertical,
      ...rest
    } = this.props;
    const classes = classnames(className, "ax-context-menu__item", `ax-context-menu__item--padding-vertical-${paddingVertical}`, {
      "ax-context-menu__item--selected": selected
    });
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      [contextMenuItemSelector]: true,
      Component: "button",
      className: classes,
      disabled: disabled,
      onClick: onClick,
      textStrong: selected
    }), multiSelect && /*#__PURE__*/React.createElement("div", {
      className: "ax-context-menu__item-checkbox"
    }, /*#__PURE__*/React.createElement(CheckBox, {
      checked: selected,
      disabled: disabled,
      indeterminate: indeterminate,
      onChange: onClick,
      onClick: e => e.stopPropagation()
    })), /*#__PURE__*/React.createElement("div", {
      className: "ax-context-menu__item-content"
    }, children), !multiSelect && selected !== undefined && /*#__PURE__*/React.createElement("div", {
      className: "ax-context-menu__item-icon"
    }, /*#__PURE__*/React.createElement(Icon, {
      cloak: !selected,
      name: "tick"
    })), icon !== undefined && /*#__PURE__*/React.createElement("div", {
      className: "ax-context-menu__item-icon"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icon
    })));
  }

}

_defineProperty(ContextMenuItem, "defaultProps", {
  paddingVertical: "medium"
});